import { createAction, props } from '@ngrx/store';

import { CheckboxOption } from 'Angular/features/components/inputs/checkbox-group/interfaces/checkbox-option.interface';

export const setComplianceDesignationTypeOption = createAction(
    '[Compliance Report History Page] Set Designation Type Option',
    props<{ designationTypeOption: CheckboxOption }>()
);
